import { gql } from '@apollo/client';

export const SET_PRODUCT_PORTFOLIO_RESTRICTION = gql`
    mutation SetProductPortfolioRestriction($hiddenCategoryIds: [String!]!, $contactId: String!) {
        setProductPortfolioRestriction(hiddenCategoryIds: $hiddenCategoryIds, contactId: $contactId)
    }
`;
